import { render, staticRenderFns } from "./reasonSection.vue?vue&type=template&id=5df246c6&scoped=true&"
import script from "./reasonSection.vue?vue&type=script&lang=js&"
export * from "./reasonSection.vue?vue&type=script&lang=js&"
import style0 from "./reasonSection.vue?vue&type=style&index=0&id=5df246c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df246c6",
  null
  
)

export default component.exports